import { Hotel } from 'tokyu-hooks'
import { toRoomPiceModel } from 'core/bookings'
import { RoomSelectInfo } from 'core/bookings/types'
import { RoomPriceInfo } from 'tokyu-hooks/lib/request/hotel'

export const QUERY_ROOMS_PRICE = 'QUERY_ROOMS_PRICE'

export const fetchRoomsPrice =
  (clientSession: string, accessToken?: string) =>
  async ({ queryKey }: { queryKey: any[] }) => {
    const [
      _key,
      {
        hotelCode,
        checkin,
        checkout,
        rooms,
        couponCode,
        spendingPoint,
        reservationNo,
        locale,
        mode,
      },
    ] = queryKey

    const res = await Hotel.getRoomsPrice({
      baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
      clientSession: clientSession,
      accessToken,
      hotelCode,
      checkin_date: checkin,
      checkout_date: checkout,
      rooms: (rooms as RoomSelectInfo[])?.map(
        (room) =>
          ({
            room_plan_code: room.roomPlanCode,
            number_of_adult: Number(room.numberOfAdult),
            number_of_children: Number(room.numberOfChildren),
            number_of_room: Number(room.numberOfRoom),
            membership_promotion_id: room.membershipPromotionId,
            plan_code: room.planCode,
            room_type_code: room.roomTypeCode,
            hotel_plan_code: room.hotelPlanCode,
          }) as RoomPriceInfo,
      ),
      coupon_code: couponCode,
      spending_point: spendingPoint,
      reservation_no: reservationNo,
      locale,
      mode,
    })

    return res?.data?.data ? toRoomPiceModel(res?.data?.data) : null
  }
